export default __webpack_public_path__ + "dist/media/ProfileAvtar.ffd45ee7.svg";